import fetch from "@/utils/request";


export default {
  ocrIdCardPhoto(data?: object): any {
    return fetch({
      url: "/php/api/ocr/card",
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data
    });
  },

  postFaceInfo(data?: object): any {
    return fetch({
      url: "/php/api/face",
      method: "post",
      data
    });
  }
};
